/**
 * ArqueiroBootstrap — monta o ChatWindow do widget de forma invisível,
 * apenas pra ativar o arqueiro (Web Worker que pinga o general da org).
 *
 * Spawn quando `authenticated=true` (disparado tanto em login quanto em
 * reload, depois do getProfile/findUser passar — ver action 'authenticated'
 * em store/auth/actionCreators.ts).
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { ChatWindow } from '@easysync-labs/chatbot-widget';
import '@easysync-labs/chatbot-widget/styles';

// Widget anexa "/arqueiro/health" e /arqueiro/submit no generalUrl,
// então passamos só a URL base do easysync-server.
const GENERAL_URL =
  process.env.REACT_APP_ARQUEIRO_URL ||
  process.env.REACT_APP_BASE_URL ||
  '';

const ArqueiroBootstrap: React.FC = () => {
  const authenticated = useSelector(
    (s: any) => s?.auth?.authenticated as boolean | undefined,
  );
  const token = useSelector(
    (s: any) => s?.auth?.token?.access_token as string | undefined,
  );

  if (!authenticated || !token) return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        width: 1,
        height: 1,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        pointerEvents: 'none',
      }}
    >
      <ChatWindow
        baseUrl=""
        token={token}
        arqueiro={{ generalUrl: GENERAL_URL }}
        storeKey="arqueiro-headless"
      />
    </div>
  );
};

export default ArqueiroBootstrap;
